"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = () => {
    return {
        schemaType: "object",
        properties: [
            {
                title: "言語コード(ISO 639-1)",
                propertyName: "langId",
                schema: {
                    schemaType: "text",
                },
                tooltip: "システム全体で利用する言語の言語コードを入力してください。ISO 639-1は2文字の言語コードです。",
            },
            {
                title: "言語名",
                propertyName: "langName",
                schema: {
                    schemaType: "text",
                },
                tooltip: "システム全体で利用する言語の表記名を入力してください。",
            },
        ],
    };
};
